<template>
  <div class="overlay">
    <v-dialog v-model="dialog" persistent max-width="600px" :retain-focus="false">
      <v-card>
        <v-toolbar dark color="primary" height="50px">
          <v-toolbar-title class="title"><span class="text-subtitle-1">{{ title ? 'Bookmaker' : 'Fancy' }} Invalid
              Bets</span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark small @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pa-2">
          <!-- <p>{{ message }}</p> -->
          <v-simple-table fixed-header dense>
            <thead>
              <tr>
                <th class="text-left">Event</th>
                <th class="text-left">Market Name</th>
                <th class="text-left">BetRate</th>
                <th class="text-left">Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr :class="items && items.type == 'BACK' ? 'secondary' : 'accent'">
                <td class="caption black--text">
                  {{ items.event || '-' }}
                </td>
                <td class="caption black--text">
                  {{ items.marketName || '-' }}
                </td>
                <td class="caption black--text">
                  {{ items.betRate || '-' }}
                </td>
                <td class="caption black--text">
                  {{ items.reason || '-' }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Default message.'
    },
    items: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      dialog: this.value
    }
  },
  watch: {
    value(newValue) {
      this.dialog = newValue
    },
    dialog(newValue) {
      this.$emit('input', newValue)
    }
  },
  methods: {
    close() {
      if (this.items && this.items._id) {
        this.$emit('close', this.items._id)
      }
      this.dialog = false
    }
  }
}
</script>

<style>
.v-overlay--active {
  z-index: 99 !important;
}

/* .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.24);
    z-index: 990; 
  } */
/* Add any custom styles here */
</style>